import Translate from 'src/language/Translate';
import homeFill from '@iconify/icons-eva/home-fill';
import fileFill from '@iconify/icons-eva/file-fill';
import roundGrain from '@iconify/icons-ic/round-grain';
import bookOpenFill from '@iconify/icons-eva/book-open-fill';
// routes
import { PATH_PAGE } from '../../routes/paths';

// ----------------------------------------------------------------------

const menuConfig = [
  { title: Translate('Start'), icon: homeFill, path: '/' },
  { title: Translate('Dla pracodawcy'), icon: roundGrain, path: PATH_PAGE.forcompanies },
  { title: Translate('Blog'), icon: roundGrain, path: PATH_PAGE.news },
  { title: Translate('FAQs'), icon: roundGrain, path: PATH_PAGE.faqs },
  { title: Translate('Kontakt'), icon: roundGrain, path: PATH_PAGE.contact },
  { title: Translate('Oferty pracy'), icon: roundGrain, path: "//asystentbiz.recruitify.ai/jobs", islink: true },
];

export default menuConfig;
